import styled from '@emotion/native';
import { useTheme } from '@emotion/react';
import { DrawerNavigationOptions } from '@react-navigation/drawer';
import { DrawerActions, useNavigation } from '@react-navigation/native';
import { BASE_SIZE, FONT_FAMILY, FONT_SIZE, Icon, PADDING } from 'design-system';
import { DrawerType, useDrawerType } from 'hooks/useDrawerType';
import { TextStyle, TouchableOpacity, ViewStyle } from 'react-native';

const drawerLabelStyle: TextStyle = {
  fontFamily: FONT_FAMILY.regular,
  fontSize: FONT_SIZE.body,
};

const headerTitleStyle: TextStyle = {
  fontFamily: FONT_FAMILY.regular,
  fontSize: FONT_SIZE.heading,
};

export const hiddenDrawerItemStyle: ViewStyle = {
  display: 'none',
};

export const Badge = styled.View(({ theme }) => ({
  backgroundColor: theme.color['risk-high'],
  width: BASE_SIZE[24],
  height: BASE_SIZE[24],
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 100,
}));

export const Wrapper = styled.View(() => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
}));
interface DrawerTypeProps {
  drawerType: DrawerType;
}

const StyledOpacity = styled(TouchableOpacity)({
  padding: PADDING.xs,
});

export const useCommonDrawerProps = (): DrawerNavigationOptions & DrawerTypeProps => {
  const theme = useTheme();
  const drawerType = useDrawerType();
  const navigation = useNavigation();
  const backgroundColor = theme.color.base;

  const headerShown = drawerType !== 'permanent';

  return {
    drawerType,
    drawerLabelStyle: {
      ...drawerLabelStyle,
      color: theme.color['text-subdued'],
    },
    headerTitleStyle: {
      ...headerTitleStyle,
      color: theme.color['text-subdued'],
    },
    headerShown,
    headerLeft: () => (
      <StyledOpacity onPress={() => navigation.dispatch(DrawerActions.openDrawer())}>
        <Icon name="menu" />
      </StyledOpacity>
    ),
    headerTintColor: theme.color['text-default'],
    headerStyle: {
      backgroundColor,
      height: BASE_SIZE[48],
      borderBottomWidth: 0,
    },
    drawerStyle: {
      backgroundColor,
    },
    drawerItemStyle: {
      backgroundColor,
    },
  };
};
